import BulkActionsDrawerItem from "components/BulkActions/Drawer/Item";
import BulkActionsDrawerItemLink from "components/BulkActions/Drawer/Item/Link";
import BulkActionsDrawerItemStatusIcon from "components/BulkActions/Drawer/Item/StatusIcon";
import BulkActionsDrawerItemStopExecutionButton from "components/BulkActions/Drawer/Item/StopExecutionButton";
import { BulkActionsResult, BulkActionsStep } from "components/BulkActions/types";
import RunStateBadge from "components/Run/elements/StateBadge";
import Box from "ds/components/Box";
import Feedback from "ds/components/Feedback";
import Link from "ds/components/Link";
import { FetchStackTriggerData } from "shared/Stack/useTriggerStack/gql";

import { StacksBulkActionsResultsItemProps } from "./Item";

const StacksBulkActionsResultsItemTrigger = ({
  stack,
  tab,
  resultsMetadata,
  status,
  stopExecution,
  polledState,
}: StacksBulkActionsResultsItemProps) => {
  const feedbackVariant = status === BulkActionsResult.Failed ? "danger" : "info";
  const triggerData = resultsMetadata?.data as FetchStackTriggerData | undefined;
  const runId = triggerData?.runTrigger?.id;
  const runState = polledState?.state ?? triggerData?.runTrigger?.state;

  return (
    <BulkActionsDrawerItem key={stack.id} direction="column" align="start">
      <Box align="center" gap="medium" fullWidth zeroMinWidth>
        <BulkActionsDrawerItemStatusIcon result={status} />
        <BulkActionsDrawerItemLink
          link={`/stack/${stack.id}`}
          text={stack.name}
          step={BulkActionsStep.Results}
          itemCategory={tab}
        />
        <BulkActionsDrawerItemStopExecutionButton onStopExecution={stopExecution} status={status} />
      </Box>

      {runId && (
        <Box gap="small" align="center">
          {runState && <RunStateBadge state={runState} />}
          <Link
            href={`/stack/${stack.id}/run/${runId}`}
            size="small"
            variant="secondary"
            target="_blank"
          >
            View triggered run
          </Link>
        </Box>
      )}

      {resultsMetadata?.message && (
        <Feedback type="banner" variant={feedbackVariant} fullWidth>
          {resultsMetadata.message}
        </Feedback>
      )}
    </BulkActionsDrawerItem>
  );
};

export default StacksBulkActionsResultsItemTrigger;
